import Vue from 'vue'
import VueRouter from 'vue-router'
import { $utils } from '@/common/helper'
import routes from './route'
import store from '@/pages/products/store'

Vue.use(VueRouter)

window.dataLayer = window.dataLayer || []
// dataLayer.push({
//   event: 'ecPageinfo',
//   behavior_country: $utils.getCountryCode(),
//   pageFullUrl: window.location.href
// })

const router = $utils.createRouter(routes, '/products')
router.beforeEach((to, from, next) => {
  if (from.name === 'CommonProductDetail' && to.name === 'CommonProductFinder') {
    // ProductDetail에서 ProductFinder로 돌아올 때 filterState와 selectedFilters 유지
    next()
  } else if (to.name === 'CommonProductFinder') {
    // 다른 페이지에서 ProductFinder로 올 때 filterState와 selectedFilters 초기화
    store.commit('SET_CATECODE_STATE', null)
    store.commit('SET_FILTER_STATE', null)
    store.commit('SET_SELECTED_FILTERS', [])
    next()
  } else {
    next()
  }
})

export default router
